import {
  buildAttrFieldKey,
  CUSTOM_ATTR_DEFINITIONS,
} from './custom-attributes.ts'
import type {
  AttrTypeSuffix,
  CustomAttrFieldIdFromDef,
} from './custom-attributes.ts'
import type {
  AnySearchFieldId,
  BuiltinSearchFieldId,
} from './search-field-ids.ts'

/** Built-ins whose option lists come from SearchFieldsConfig.fetchOptions. */
const REMOTE_BUILTIN_OPTION_FIELD_IDS = [
  'Tag',
  'Type',
  'CreatedUser',
  'ModifiedUser',
  'OwnerUser',
] as const satisfies readonly BuiltinSearchFieldId[]

type NonBoolCustomAttrDefinition = Exclude<
  (typeof CUSTOM_ATTR_DEFINITIONS)[number],
  { suffix: 'bool' }
>

type RemoteBuiltinOptionFieldId =
  (typeof REMOTE_BUILTIN_OPTION_FIELD_IDS)[number]
type RemoteCustomAttrFieldId =
  CustomAttrFieldIdFromDef<NonBoolCustomAttrDefinition>
export type RemoteOptionFieldId =
  RemoteBuiltinOptionFieldId | RemoteCustomAttrFieldId

function fieldIdFromDefinition<
  D extends { name: string; suffix: AttrTypeSuffix },
>(definition: D): CustomAttrFieldIdFromDef<D> {
  return buildAttrFieldKey(
    definition.name,
    definition.suffix,
  ) as CustomAttrFieldIdFromDef<D>
}

function isBoolAttrSuffix(suffix: AttrTypeSuffix): boolean {
  return suffix === 'bool'
}

function buildRemoteCustomAttrFieldIds(): RemoteCustomAttrFieldId[] {
  const ids: RemoteCustomAttrFieldId[] = []
  for (const definition of CUSTOM_ATTR_DEFINITIONS) {
    if (isBoolAttrSuffix(definition.suffix)) {
      continue
    }
    ids.push(fieldIdFromDefinition(definition))
  }
  return ids
}

/** Package fields whose options are loaded via fetchOptions (not schema `values`). */
export const REMOTE_OPTION_FIELD_IDS: readonly RemoteOptionFieldId[] = [
  ...REMOTE_BUILTIN_OPTION_FIELD_IDS,
  ...buildRemoteCustomAttrFieldIds(),
]

const PACKAGE_REMOTE_OPTION_FIELD_IDS = new Set<string>(REMOTE_OPTION_FIELD_IDS)

export function isPackageRemoteOptionFieldId(
  fieldId: AnySearchFieldId,
): boolean {
  return PACKAGE_REMOTE_OPTION_FIELD_IDS.has(fieldId)
}
